import React from "react"
import { useTranslate } from "ra-core"

export function Fullscreen(props: {colorMode: string, onClick: React.MouseEventHandler<HTMLButtonElement>}): JSX.Element {
  const { colorMode, onClick } = props
  const translate = useTranslate()
  const strokeColor = colorMode === 'dark' ? '#fff' : '#000'

  return (
    <button onClick={onClick} type="button" className="react-flow__controls-button" title={translate("internal.fullscreen")}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" height="24" width="24">
        <path d="m9 15-6 6m0 0v-5m0 5h5m7-12 6-6m0 0v5m0-5h-5" stroke={strokeColor} stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      </svg>
    </button>
  )
}
